/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PieChartDataDto
 */
export interface PieChartDataDto {
    /**
     * 
     * @type {string}
     * @memberof PieChartDataDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PieChartDataDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PieChartDataDto
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof PieChartDataDto
     */
    absoluteValue: number;
}

export function PieChartDataDtoFromJSON(json: any): PieChartDataDto {
    return PieChartDataDtoFromJSONTyped(json, false);
}

export function PieChartDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PieChartDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'value': json['value'],
        'absoluteValue': json['absoluteValue'],
    };
}

export function PieChartDataDtoToJSON(value?: PieChartDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
        'absoluteValue': value.absoluteValue,
    };
}

